import { PinComponent } from '@lessonup/pins-shared';
import {
  borderRadius,
  color,
  fontSizeMap,
  IconAnimation,
  SpaceBetween,
  spacing,
  styled,
  TextElement,
} from '@lessonup/ui-components';
import React from 'react';
import { usePinContext } from '../../contexts/pinContext';
import { getAnimationOrder } from './getAnimationOrder';

export interface AnimationTagProps {
  pinComponent: PinComponent;
}

/**
 * Size the Figma design uses.
 */
const size = fontSizeMap['label']['small'];

/**
 * AnimationTag displays an animation icon and order number for animated pin components.
 * This is part of the UI layer, not lesson content.
 *
 * Calculates the animation order based on the component's position in the sorted list
 * of all animated components in the pin.
 */
export const AnimationTag: React.FC<AnimationTagProps> = ({ pinComponent }) => {
  const pin = usePinContext();

  const animationOrder = getAnimationOrder(pin, pinComponent);

  if (animationOrder === null) {
    return null;
  }

  return (
    <Wrapper direction="x" spacing={spacing.size6} alignItems="center">
      <IconAnimation
        style={{
          height: size,
          width: size,
        }}
      />
      <TextElement textStyle="label" size="small">
        {animationOrder}
      </TextElement>
    </Wrapper>
  );
};

const Wrapper = styled(SpaceBetween)`
  background: ${color.state.active.stroke};
  color: ${color.state.active.on};
  padding: ${spacing.size4} ${spacing.size8};
  border-radius: ${borderRadius.rounded4};
  border: 1px solid ${color.neutral.surface.background};
  font-size: ${size};
`;
